import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userInvitationSuccess: false,
  userInvitationInfo: {
    isSent: null,
    message: "",
  },
  userSignUpInfo: {
    isSent: null,
    message: "",
  },
  invitedUserEmail: "",
  userSignUpMessage: "",
  userSignUpFailure: false,
  invitedUserEmailInfo: {
    emailGet: null,
    message: "",
  },
  userInvitationValue: "",
  disableBtn: false,
  loading: false,
};

export const userInvitationSlice = createSlice({
  name: "UserInvitationSlice",
  initialState,
  reducers: {
    setUserInvitationSuccess: (state, action) => {
      state.userInvitationSuccess = action.payload;
    },
    setInvitedUserEmail: (state, action) => {
      state.invitedUserEmail = action.payload;
    },
    setUserSignUpMessage: (state, action) => {
      state.userSignUpMessage = action.payload;
    },
    setUserInvitationInfo: (state, action) => {
      state.userInvitationInfo = action.payload;
    },
    setUserSignUpInfo: (state, action) => {
      state.userSignUpInfo = action.payload;
    },
    setInvitedUserEmailInfo: (state, action) => {
      state.invitedUserEmailInfo = action.payload;
    },
    setUserInvitationValue: (state, action) => {
      state.userInvitationValue = action.payload;
    },
    setDisableBtn: (state, action) => {
      state.disableBtn = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const {
  setInvitedUserEmail,
  setUserSignUpMessage,
  setUserInvitationInfo,
  setUserSignUpInfo,
  setInvitedUserEmailInfo,
  setUserInvitationValue,
  setDisableBtn,
  setLoading,
} = userInvitationSlice.actions;

export default userInvitationSlice.reducer;
